<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ورود به آزمایشگاه</h5>



    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #396f9b; color: white;">
          <tr>
            <th>#</th>
            <th>نام و نام خانوادگی</th>
            <th>امتیاز دستگاه تحویل داده شده</th>
            <th>تعداد دستگاه تحویل داده شده</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DetailDownload">
            <td>{{DetailDownload.indexOf(item)+1}}</td>
            <td>{{item['fullname']}}</td>
            <td>{{item['devicePoint']}}</td>
            <td>{{item['deviceCount']}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <br />

    <ul>
      <li>قبل از اسکن در کادر مربوطه کلیک کنید</li>
      <li>برای بررسی کد اسکن شده می توانید کلیک Enter را فشار دهید</li>
      <li>برای پاک کردن فرم مربوطه می توانید کلیک ESC را فشار دهید</li>

    </ul>

    <br />
    <br />

    <form>
      <button type="button" (click)="openModal_ExpertCalibration(templateExpertCalibration,-1)" class="btn btn-danger"
                style="margin-left: 5px;"> جستجوی کارشناس کالیبراسیون <i class="fa fa-user-circle-o"></i>
      </button>
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> نام </label>
          <input type="text" class="form-control" disabled value="{{Data_Seleted_ExpertCalibration.name}}" />
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">نام خانوادگی </label>
          <input type="text" class="form-control" disabled value="{{Data_Seleted_ExpertCalibration.familly}}" />
        </div>
      </div>


      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> قبل از اسکن QR Code در کادر پایین کلیک کنید <i class="fa fa-arrow-down"></i>
          </label>
          <input #QRCodeInputDownload type="text" (keyup.enter)="QRCodeInputDownload_Enter()"
            (keyup.esc)="QRCodeInputDownload_Esc()"
            style="font-family: Arial, Helvetica, sans-serif;background-color: #dfdddd;" class="form-control EnglishClm"
            placeholder="اینجا کلیک کنید ...">
          <p [hidden]="!Procssing"> لطفا صبر نمائید ... <i class="fa fa-spin fa-refresh"></i> </p>

        </div>
      </div>

      <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />

      <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeChangeDownload()" type="button"
        [disabled]="Info_Download_List.length==0 || Data_Seleted_ExpertCalibration.id==0" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت ورود دستگاه های اسکن شده </button>

      <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeInputDownload_Enter()" type="button"
        class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> بررسی شناسه دستگاه </button>

      <button *ngIf="!Procssing && FormSubmitted" (click)="ResetForm()" type="button" class="btn btn-danger"
        style="margin-left: 5px;"><i class="fa  fa-recycle"></i> شروع مججد </button>

      <button routerLink="/LabDownloadUploadDevice" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> بازگشت </button>
    </form>

    <br />
    <br />

    <div class="row" *ngIf="Info_Download_List.length>0">
      <div class="form-group col-md-12">
        <div class="table-responsive">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>عنوان دستگاه</th>
                <th>کد دستگاه</th>
                <th>سریال دستگاه</th>
                <th *ngIf="!FormSubmitted">QR Code</th>
                <th *ngIf="FormSubmitted">پیغام سیستم</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Info_Download_List">
                <td>{{Info_Download_List.indexOf(item)+1}}</td>
                <td>{{item.userDsc}}</td>
                <td>{{item.code}}</td>
                <td>{{item.title}}</td>
                <td *ngIf="item.id==0">{{item.dsc}}</td>
                <td *ngIf="item.id>0" style="color: green;">{{item.dsc}}</td>
                <td *ngIf="item.id<0" style="color: red;">{{item.dsc}}</td>
                <td>
                  <button *ngIf="!FormSubmitted" (click)="Info_Download_Remove(Info_Download_List.indexOf(item))"
                    class="btn btn-danger"><i class="fa fa-remove"></i> حذف </button>
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


  </div>
</div>





<ng-template #templateExpertCalibration>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست کارشناس کالیبراسیون </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ExpertCalibration.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">نام خانوادگی</label>
          <input [(ngModel)]="Filter_Familly" (keyup)="Change_Filter()" name="Filter_Familly" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام</th>
              <th>نام خانوادگی</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_ExpertCalibration
            |filter:Filter_Familly:'familly'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 20,
                        currentPage: ExpertCalibrationpage,
                        totalItems: (DataList_ExpertCalibration
                        |filter:Filter_Familly:'familly'
                        ).length
                      }
            ">
              <td>{{DataList_ExpertCalibration.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.familly}}</td>
              <td (click)="Set_Selected_ExpertCalibration_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_ExpertCalibration" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_ExpertCalibration" type="button" (click)="ReadData_ExpertCalibration()"
      class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_ExpertCalibration.hide()">بستن</button>
  </div>
</ng-template>
